import React from 'react';
import { ScrollArea } from '@shared/ui/scroll-area';
import { RecentPage } from '@shared/activity/types';
import { RecentPageNode } from './RecentPageNode';
import { RecentEmptyState } from './RecentEmptyState';
import { RecentShowMore } from './RecentShowMore';
import { useRecentExpansion } from './useRecentExpansion';

export const RecentList: React.FC<{ pages: RecentPage[] }> = ({ pages }) => {
  const { visible, hiddenCount, expanded, toggle, canToggle } = useRecentExpansion(pages);

  if (pages.length === 0) {
    return <RecentEmptyState />;
  }

  return (
    <ScrollArea className="flex-1">
      <div className="p-2 space-y-0.5" role="tree" aria-label="Recent pages and actions">
        {visible.map((page) => (
          <RecentPageNode key={page.key} page={page} />
        ))}
      </div>
      {canToggle && (
        <div className="px-2 pb-2">
          <RecentShowMore expanded={expanded} hiddenCount={hiddenCount} onToggle={toggle} />
        </div>
      )}
    </ScrollArea>
  );
};
